import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/base.service';
import { FiltersTypeEnum, FiltersComponentInterface, IFilterComboComponent, IFilterTextComponent } from 'world-archery-lib';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs';
import { mergeMap, tap, map, filter } from 'rxjs/operators';
import { PrizeForPrecisionCategories, PrizeForPrecisionYear } from '../classes/prize-for-precision';

import * as op from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ActivatedRoute } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class PrizeForPrecisionService {
  readonly filtersType: any = [
    {
      options: {
        type: FiltersTypeEnum.TextSearch,
        intercept_name:'search',
        id: 'prizeforprecisiontextfilter',
        defaultTextValue: '',
        text_subject: new BehaviorSubject('')
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name:'year',
        initial_state: true,
        name_filter: 'Year',
        options_subject: new BehaviorSubject<Array<any>>([]),
        option_name_property: 'Year',
        options_selected_subject: new BehaviorSubject<any>({} as any),
        id: 'prizeforprecisionyear'
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name:'category',
        name_filter: 'Categories',
        options_subject: new BehaviorSubject<Array<PrizeForPrecisionCategories>>([

        ]),
        option_name_property: 'CatName',
        options_selected_subject: new BehaviorSubject<PrizeForPrecisionCategories>({} as any),
        id: 'prizeforprecisiondiscipline'
      }
    }

  ];
  country: Array<any> = [];
  sort: { asc: boolean, category: string } = {
    asc: true, category: 'RANKING'
  }
  public categoriesSubject = new BehaviorSubject(undefined);
  private changeSubject: BehaviorSubject<{ asc: boolean, category: string }> = new BehaviorSubject(this.sort);
  generateDefaultValues(): Observable<{ year: number, catCode: string, text: string, sort: any }> {
    return combineLatest(
      (this.filtersType[0].options as IFilterTextComponent).text_subject.asObservable().pipe(op.debounceTime(300)),
      (this.filtersType[1].options as IFilterComboComponent).options_selected_subject.asObservable(),
      (this.filtersType[2].options as IFilterComboComponent).options_selected_subject.asObservable(),
      this.changeSubject.asObservable()
    ).pipe(
      map(([text, year, category, sort]) => {
        return { text: text, year: year ? year.Year : undefined, catCode: category ? category.Cat : undefined, sort: sort, wCupStage: category ? category.WCupStage : undefined }
      }),
      filter(a => a.catCode !== undefined && a.year !== undefined)
    )

  }

  constructor(private http: HttpClient, private route:ActivatedRoute) {
    this.http.get(environment.api_url, { params: new HttpParams({ fromObject: { content: 'COUNTRIES', v: String(3), RBP: 'ALL' } }) })
      .subscribe(next => this.country = (next as any).items)

    this.http.get<{ items: Array<PrizeForPrecisionYear> }>(environment.api_url,
      { params: new HttpParams({ fromObject: { content: environment.priceForPrecision.apiYearData, RBP: 'ALL', v: String(3) } }) })

      .pipe(
        map(a => a.items.filter(value => value.PrecisionPrize === true)),
        tap(a => {
          let selected = a[0]
          if(this.route.snapshot.queryParams['year']){
            const indexYear = a.findIndex(value => value.Year.toString() === this.route.snapshot.queryParams['year']);
            if(indexYear > -1){
              selected = a[indexYear];
            }
          }
          (this.filtersType[1].options as IFilterComboComponent).options_selected_subject.next(selected);
          (this.filtersType[1].options as IFilterComboComponent).options_subject.next(a);
        })).subscribe();

    (this.filtersType[1].options as IFilterComboComponent)
      .options_selected_subject.asObservable()
      .pipe(
        filter(a => a !== undefined),
        mergeMap(a => {
          return this.http.get<{ items: Array<PrizeForPrecisionCategories> }>(environment.api_url,
            { params: new HttpParams({ fromObject: { v: String(3), content: environment.priceForPrecision.apiContentCategories, Year: a.Year, RBP: 'ALL' } }) })
            .pipe(
              tap(data => {
                const arr = data.items.filter(value => value.seasonPrize === true);
                this.categoriesSubject.next(data);
                (this.filtersType[2].options as IFilterComboComponent).options_subject.next(arr);


              }))
        })).subscribe();
  }
  modifyOrderValue(next: any) {
    this.changeSubject.next(next);
  }

}
